import { ApiTypes } from '../../types';
import { hasInvitePermission, isAdmin, isJoined, } from './MemberRole';
import { isEmptyGroup, isGroupPublic, isGroupSecret, } from '../Group/GroupPrivacy';
import { isAnonymous } from './Member';
export function canSeeFeed(group) {
    return !isEmptyGroup(group) && canSeeGroup(group);
}
export function canApprovePendingMembers(currentMember, group) {
    return (isAdmin(currentMember) ||
        (!isAnonymous(currentMember) &&
            group.settings.permittedToApproveMembers ===
                ApiTypes.v1.RoleInGroup.GROUP_MEMBER));
}
export function canSeeGroup(group) {
    return isGroupPublic(group) || isAdmin(group) || isJoined(group);
}
export function canJoinGroup(group) {
    return !isGroupSecret(group) || isAdmin(group);
}
export function canWritePost(group) {
    return isJoined(group);
}
export function canInviteMembers(group) {
    return isAdmin(group) || hasInvitePermission(group);
}
export function canEdit(group) {
    return isAdmin(group);
}
export function canFetchAllMembers(group) {
    return (isAdmin(group) ||
        group.settings.permittedToInviteMembers ===
            ApiTypes.v1.RoleInGroup.GROUP_MEMBER);
}
export function canSeeMembers(group) {
    var isPublic = isGroupPublic(group);
    return isAdmin(group) || isPublic || isJoined(group);
}
//# sourceMappingURL=permissions.js.map